<app-notification-box
  *ngIf="show"
  [pageId]="'unsupported-browser'"
  [bottomMargin]="false"
  [inlineActionButton]="true"
></app-notification-box>
